import { injectable } from "inversify";
import type { SelectedContactType } from "@whatslly/types/SelectedContactType";
import type { QueryResponseType } from "@whatslly/types/QueryResponse";
import { QUERY_RESPONSE_PERSON_TYPES } from "@whatslly/types/Person";

@injectable()
export class ContactService {
  private currentContact?: {
    contact: SelectedContactType;
    query: QueryResponseType;
  };

  get isWhitelisted() {
    if (!this.currentContact || !this.currentContact.query.success) return true;
    return !Array.isArray(this.currentContact.query.person)
      ? this.currentContact.query.person?.type !== QUERY_RESPONSE_PERSON_TYPES.BLACKLISTED
      : !this.currentContact.query.person.some((p) => p.type === QUERY_RESPONSE_PERSON_TYPES.BLACKLISTED);
  }

  get contact() {
    return this.currentContact;
  }

  set contact(
    contact:
      | {
          contact: SelectedContactType;
          query: QueryResponseType;
        }
      | undefined
  ) {
    this.currentContact = contact;
  }
}
